import * as common from '@/util/common'

/**
 * お見積もり内容のパッケージ＆商品リストを表示用に整形する
 * @param {array} packageLists お見積もり内容のパッケージ＆商品リスト
 */
export const arrangePackageLists = (packageLists) => {

  const listWork = []

  for (let i = 0; i < packageLists.length; i++) {

    const packageName = common.breakComma(packageLists[i].package_name)
    const subTotalFee = common.breakComma(packageLists[i].sub_total_fee)
    const periodEnd = common.formatDate(packageLists[i].period_end)

    const basicProductLists = []
    const optionProductLists = []

    for (let k = 0; k < packageLists[i].product_lists.length; k++) {
      const map = packageLists[i].product_lists[k]

      const basicPrice = map.basic_price
      const addPrice = map.add_price
      const periodStart = map.period_start
      const periodEnd = map.period_end

      map.basic_price = common.breakComma(basicPrice)
      map.add_price = common.breakComma(addPrice)
      map.period_expression = common.dateDiff(periodStart, periodEnd)
      map.period_start = common.formatDate(periodStart)
      map.period_end = common.formatDate(periodEnd)

      if (map.classification === 2) {
        // 2:基本商品の場合
        basicProductLists.push(map)
      } else if (map.classification === 3) {
        // 3:オプション商品の場合
        optionProductLists.push(map)
      }
    }

    const map2 = {
      package_name: packageName,
      sub_total_fee: subTotalFee,
      period_end: periodEnd,
      basic_products: basicProductLists,
      option_products: optionProductLists
    }
    listWork.push(map2)

  }

  return listWork
}
